module.exports = __webpack_public_path__ + "img/logo_px40_clara_B&W.d5e75f63.png";